


















import { Component, Vue } from 'vue-property-decorator';
import { permissionManage } from '../permission';
import EditUsers from '../../components/editUsers.vue';
import EditRoles from '../../components/editRoles.vue';


@Component({
  components: {
    EditUsers,
    EditRoles,
  },
})
export default class PermissionModal extends Vue {
  private componentName = '';
  private type = 'add';
  private visible = false;
  private title = '';
  private roles: IRole.IResponse.IRoleInfo[] = [];
  private users: IUser.IResponse.IUserDetailInfo[] = [];
  public showModal(component = 'edit-users', type: 'add' | 'del' = 'add') {
    this.visible = true;
    this.componentName = component;
    if (component === 'edit-users') {
      this.type = type;
      this.title = this.$t('permission.updateUser').toString();
      this.users = permissionManage.editData.permissionInfo?.user || [];
      return;
    }
    if (component === 'edit-roles') {
      this.type = type;
      this.title = this.$t('permission.updateRole').toString();
      this.roles = permissionManage.editData.permissionInfo?.roles || [];
      return;
    }
  }
  public addRoles(roleIds: string[]): Promise<string> {
    return permissionManage.requestAddRoles(roleIds);
  }
  public delRoles(roleIds: string[]): Promise<string> {
    return permissionManage.requestDelRoles(roleIds);
  }
  public addUsers(userIds: string[]): Promise<string> {
    return permissionManage.requestAddUsers(userIds);
  }
  public delUsers(userIds: string[]): Promise<string> {
    return permissionManage.requestRemoveUsers(userIds);
  }
}
